import HttpData from "@/http/data/http-data";

export enum AccessControlEventType {
    None = 0,
    CardSwipe = 1,
    Door = 2,
    Alarm = 3,
    Overwritten = 255
}

export enum AccessControlEventDirection {
    In = 1,
    Out = 2
}

export enum AccessControlEventReason {
    Swipe = 1,
    SwipeOpen = 2,
    SwipeClose = 3,
    SwipeDeniedSystem = 5,
    NoAccessRights = 6,
    IncorrectPassword = 7,
    AntiPassback = 8,
    MoreCards = 9,
    FirstCardOpen = 10,
    DoorNormallyClosed = 11,
    Interlock = 12,
    NotInAllowedTimePeriod = 13,
    InvalidTimezone = 15,
    AccessDenied = 18,
    PushButtonOk = 20,
    DoorOpened = 23,
    DoorClosed = 24,
    DoorOpenedSupervisorPassword = 25,
    ControllerPowerOn = 28,
    ControllerReset = 29,
    PushbuttonInvalidDoorLocked = 31,
    PushbuttonInvalidOffline = 32,
    PushbuttonInvalidInterlock = 33,
    PushbuttonInvalidThreat = 34,
    DoorOpenTooLong = 37,
    ForcedOpen = 38,
    Fire = 39,
    ForcedClosed = 40,
    TheftPrevention = 41,
    Zone24x7 = 42,
    Emergency = 43,
    RemoteOpenDoor = 44,
    RemoteOpenDoorUsbReader = 45
}

export interface IAccessControlEventData {
    device_id: number;
    event_id: number;
    event_type: AccessControlEventType;
    event_type_text: string;
    access_granted: boolean;
    door_id: number;
    direction: AccessControlEventDirection;
    direction_text: string;
    card_number: number;
    timestamp: string;
    event_reason: AccessControlEventReason;
    event_reason_text: string;
}

export default class AccessControlEventData extends HttpData {
    public device_id: number;
    public event_id: number;
    public event_type: AccessControlEventType;
    public event_type_text: string;
    public access_granted: boolean;
    public door_id: number;
    public direction: AccessControlEventDirection;
    public direction_text: string;
    public card_number: number;
    public timestamp: string;
    public event_reason: AccessControlEventReason;
    public event_reason_text: string;

    constructor(data: IAccessControlEventData) {
        super();

        this.device_id = data.device_id;
        this.event_id = data.event_id;
        this.event_type = data.event_type;
        this.event_type_text = data.event_type_text;
        this.access_granted = data.access_granted;
        this.door_id = data.door_id;
        this.direction = data.direction;
        this.direction_text = data.direction_text;
        this.card_number = data.card_number;
        this.timestamp = data.timestamp;
        this.event_reason = data.event_reason;
        this.event_reason_text = data.event_reason_text;
    }
}
